import { createContext } from "react";

export const PlacementsContext = createContext();

PlacementsContext.displayName = "PlacementsContext";
